var app = angular.module("leonardo");

var AuditDialog = function($scope) {

  $scope.submit = function(all) {
    var result = all || $scope.ngDialogData.auditsPage;
    $scope.confirm(result);
  };
};

app.controller('AuditDialog', ['$scope', AuditDialog]);
